

export class PaginationControl {
    currentPage: number = 0;
    fields: string = '';
    criteria: string = '';

    constructor (){
        this.currentPage = 0;
        this.fields = '';
        this.criteria = '';
    }
    setFields(fields: string) {
        if (this.fields == undefined || this.fields.length == 0) {
            this.fields = fields;
        }
    }

    setCriteria(criteria: string) {
        this.criteria = criteria;
    }
    
    moveNextPage() {
        this.currentPage = this.currentPage + 1;
    }

    movePreviousPage() {
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage - 1;
        }
    }

    moveTopPage() {
        this.currentPage = 0;
    }

    isFirstPage() {
        return this.currentPage === 0; 
    }
}
